"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableImporter = void 0;
var table_cell_properties_1 = require("../../../core/model/tables/properties/table-cell-properties");
var table_properties_1 = require("../../../core/model/tables/properties/table-properties");
var table_row_properties_1 = require("../../../core/model/tables/properties/table-row-properties");
var TableImporter = (function () {
    function TableImporter(data) {
        this.data = data;
    }
    Object.defineProperty(TableImporter.prototype, "isInsideTable", {
        get: function () { return this.data.subDocumentInfo.tableStack.count > 0; },
        enumerable: false,
        configurable: true
    });
    TableImporter.prototype.cancelTable = function (table) {
        var tables = this.data.subDocument.tables;
        tables.splice(tables.indexOf(table), 1);
        this.data.subDocumentInfo.tableStack.pop();
    };
    TableImporter.prototype.createDefaultTableProperties = function () {
        return new table_properties_1.TableProperties();
    };
    TableImporter.prototype.createDefaultRowProperties = function () {
        return new table_row_properties_1.TableRowProperties();
    };
    TableImporter.prototype.createDefaultCellProperties = function () {
        return new table_cell_properties_1.TableCellProperties();
    };
    return TableImporter;
}());
exports.TableImporter = TableImporter;
